import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/VisibilityRounded";
import VisibilityOff from "@mui/icons-material/VisibilityOffRounded";
import { styled } from "@mui/material/styles";

// Premium styled input - Unified Luminous Design
const NebulaTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
    borderRadius: '12px', /* Pill-like */
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)', /* Subtle shadow */
    '& fieldset': {
      border: '1px solid #e2e8f0', /* Very subtle grey border */
    },
    '&:hover': {
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
        transform: 'translateY(-1px)'
    },
    '&:hover fieldset': {
      borderColor: '#cbd5e1',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--primary-color)',
      borderWidth: '2px',
      boxShadow: '0 0 0 0px transparent', /* Remove default MUI halo, use border */
    },
    '&.Mui-focused': {
       boxShadow: '0 20px 25px -5px rgba(79, 70, 229, 0.15), 0 8px 10px -6px rgba(79, 70, 229, 0.1)',
       transform: 'translateY(-2px)',
    }
  },
  '& .MuiInputLabel-root': {
    color: '#64748b',
    fontWeight: 500,
    fontSize: '0.95rem',
    '&.Mui-focused': {
      color: 'var(--primary-color)',
      fontWeight: 600,
    },
  },
  '& input': {
      padding: '14px',
      color: '#1e293b',
      fontWeight: 500,
  }
});

const PasswordInput = ({ value, onChange, error, fieldName }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <NebulaTextField
      type={showPassword ? "text" : "password"}
      label={fieldName || "Password"}
      variant="outlined"
      placeholder="••••••••"
      fullWidth
      value={value}
      onChange={onChange}
      error={error}
      required
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton 
              onClick={togglePasswordVisibility}
              edge="end"
              sx={{ color: '#94a3b8', '&:hover': { color: 'var(--primary-color)' } }}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      helperText={error && "Password must be 8-15 characters with a mix of lowercase letters, uppercase letters, numbers, and symbols"}
    />
  );
};

export default PasswordInput;
